import { getRouteApi } from '@tanstack/react-router';
import { AuthImagePanel, OtpLoginPage as SharedOtpLoginPage } from '@discovr/ui';
import { useAuth } from '@discovr/common';
import { auth as authApi } from '@discovr/api';
import { BRAND_APP_SURFACE } from '@/auth/appSurface';
import { usePostLoginRedirect } from '@/auth/usePostLoginRedirect';
import { usePendingClaimReturnPath } from '@/auth/pendingClaimReturn';
import { shopifyCopy } from '@discovr/features/copy';

const otpLoginRoute = getRouteApi('/login/code');

export default function OtpLoginPage() {
  const { email, link_token: linkToken, redirect } = otpLoginRoute.useSearch();
  const { user, signInWithOtpToken } = useAuth();
  const hasPendingClaim = usePendingClaimReturnPath() !== null;

  // Also fires when another tab signs in (magic link opened in a new tab).
  usePostLoginRedirect(redirect);

  return (
    <SharedOtpLoginPage
      appName="Discovr"
      codeHint={hasPendingClaim && !user && !linkToken ? shopifyCopy.claim.signInCodeHint : undefined}
      linkToken={linkToken}
      initialEmail={email}
      sidePanel={<AuthImagePanel />}
      backSearch={{ redirect }}
      onRequestOtp={async (emailAddr) => {
        await authApi.requestOtp(emailAddr, BRAND_APP_SURFACE);
      }}
      onVerifyOtp={async ({ email: emailAddr, code, linkToken: token }) => {
        const { firebaseCustomToken } = await authApi.verifyOtp({
          email: emailAddr,
          app: BRAND_APP_SURFACE,
          code,
          linkToken: token,
        });
        await signInWithOtpToken(firebaseCustomToken);
      }}
    />
  );
}
